import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRefresh,
} from "react-admin";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MuiButton from "@mui/material/Button";
import { RazaEventItsPickerInput } from "@/components/raza/RazaEventItsPickerInput";
import {
  toKhidmatguzarPartialUpdate,
  toZakereenPartialUpdate,
} from "../raza-event-partial-edit-payload";

function PartialEditToolbar({ onCancel }: { onCancel: () => void }) {
  return (
    <Toolbar
      sx={{
        bgcolor: "transparent",
        boxShadow: "none",
        display: "flex",
        justifyContent: "flex-end",
        gap: 1,
        px: { xs: 0, sm: 2 },
        mt: { xs: 2, sm: 1 },
        minHeight: "auto",
        flexWrap: "wrap",
      }}
    >
      <MuiButton type="button" onClick={onCancel}>
        Cancel
      </MuiButton>
      <SaveButton />
    </Toolbar>
  );
}

export function ChangeKhidmatDialog({
  open,
  onClose,
  majlisId,
}: {
  open: boolean;
  onClose: () => void;
  majlisId: string | number;
}) {
  const refresh = useRefresh();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Change khidmatguzar</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Edit
          key={`khidmat-${majlisId}`}
          resource="raza-events"
          id={majlisId}
          mutationMode="pessimistic"
          redirect={false}
          actions={false}
          transform={toKhidmatguzarPartialUpdate}
          mutationOptions={{
            onSuccess: () => {
              refresh();
              onClose();
            },
          }}
        >
          <SimpleForm toolbar={<PartialEditToolbar onCancel={onClose} />}>
            <ReferenceInput
              source="khidmatguzarItsNo"
              reference="itsdata"
              filter={{ forKhidmatguzarPicker: true }}
              allowEmpty
              perPage={50}
            >
              <AutocompleteInput
                optionText={(r) => `${r.ITS_ID} — ${r.Full_Name || ""}`}
                optionValue="ITS_ID"
                label="Khidmatguzar"
                filterToQuery={(q) => ({ q: q || "", forKhidmatguzarPicker: true })}
                emptyText="— None —"
                debounce={300}
                fullWidth
              />
            </ReferenceInput>
          </SimpleForm>
        </Edit>
      </DialogContent>
    </Dialog>
  );
}

export function ChangeZakereenDialog({
  open,
  onClose,
  majlisId,
}: {
  open: boolean;
  onClose: () => void;
  majlisId: string | number;
}) {
  const refresh = useRefresh();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Change zakereen</DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Edit
          key={`zakereen-${majlisId}`}
          resource="raza-events"
          id={majlisId}
          mutationMode="pessimistic"
          redirect={false}
          actions={false}
          transform={toZakereenPartialUpdate}
          mutationOptions={{
            onSuccess: () => {
              refresh();
              onClose();
            },
          }}
        >
          <SimpleForm toolbar={<PartialEditToolbar onCancel={onClose} />}>
            <RazaEventItsPickerInput source="zakereenItsNo" label="Zakereen" />
          </SimpleForm>
        </Edit>
      </DialogContent>
    </Dialog>
  );
}
